import type { Locale } from '../../i18n';
import { LOCALE_NATIVE_LABELS, messagesFor } from '../../i18n';
import { useAppStore } from '../../state/store';
import { Modal } from '../components/controls';

const OPTIONS: Locale[] = ['en', 'uk'];

export function LanguageDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const locale = useAppStore((state) => state.locale);
  const setLocale = useAppStore((state) => state.setLocale);
  const t = messagesFor(locale);

  return (
    <Modal
      open={open}
      title={t.languageTitle}
      onClose={onClose}
      footer={
        <button type="button" className="button button--primary" onClick={onClose}>
          {t.close}
        </button>
      }
    >
      <p className="dialog__note">{t.languageHint}</p>
      <div className="language-options">
        {OPTIONS.map((value) => {
          const active = locale === value;
          return (
            <button
              key={value}
              type="button"
              className={`language-options__btn${active ? ' language-options__btn--active' : ''}`}
              onClick={() => setLocale(value)}
            >
              {LOCALE_NATIVE_LABELS[value]}
            </button>
          );
        })}
      </div>
    </Modal>
  );
}
